
import {NHVirtualForm} from '../../../../../utils/NHVirtualForm.js';
import { List, Flex, Button, Modal, Table, message } from "antd";
let md5 = require("md5");

/**
 * 网上支付办理接口
 * 请自行在此处判断需要的参数是否符合要求，例如判断身份证件号是否为空，Toast.hide()，可以使用改方法关闭准备跳转支付界面提示
 *
 * @param {*} csxx 配置参数信息，包含：pczflj(PC端支付路径),ydzflj(移动端支付路径)，zfts(支付提示),所有的自定义配置的参数信息
 * @param {*} xsxx 学生信息，包含：XSID(学生ID),XH(学号),XM(姓名),XBM(性别码),SFZJH(身份证件号),RXNF(入学年份),CSRQ(出生日期)
 */
export const handle = (csxx,xsxx) => {
  
  let xh=xsxx.XH;//学号
  let url=csxx.pcUrl;//单点登录连接地址

  if(!url){
    message.info("单点登录连接地址不能为空，请联系管理员！");
    return;
  }

  //虚拟表单提交
  let map={
    cid:xsxx.XSID,
    user_name:xsxx.XM,
    school_code:csxx.schoolCode,
    account_type:csxx.accountType || 'IDCARD',
    account_no:csxx.accountType && csxx.accountType == 'STUNO' ? xsxx.XH : xsxx.SFZJH,//STUNO代表学号
    app_code:csxx.appCode,
    back_url:csxx.turnBackUrl,
    mark:window.location.href
  }
  let signature = md5(JSON.stringify(map)+csxx.appKey+csxx.signKey);
  let params = {
      json:JSON.stringify(map),
      appkey:csxx.appKey,
      signature:signature
  }
//   NHVirtualForm(url+'/wac/e/apiForKk/wac/skipToPC',"_blank",params);
  NHVirtualForm(url,"_blank",params);


}

/**
 * 点击同步按钮触发时的操作
 * @param {*} ddh 订单号
 */
export const syscBtnFunc = (ddh) => {

}


//获取当前日志，格式yyyyMMdd
function getNowFormatDate() {
  var date = new Date();
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var hours = date.getHours(); //获取系统时，
var minutes = date.getMinutes(); //分
var seconds = date.getSeconds(); //秒
  var strDate = date.getDate();

  if (month >= 1 && month <= 9) {
      month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
  }
  if (hours >= 0 && hours <= 9) {
      hours = "0" + hours;
  }
  if (minutes >= 0 && minutes <= 9) {
      minutes = "0" + minutes;
  }
  if (seconds >= 0 && seconds <= 9) {
      seconds = "0" + seconds;
  }
  var currentdate = year  + month  + strDate + hours + minutes + seconds;;
  return currentdate;
}
